// Aparencia e prioridade dos alertas de cobranca. Compartilhado entre o modal
// de historico e o grid da tela de cobranca: o mesmo alerta precisa ter a
// mesma cor e o mesmo icone nos dois lugares.
export const niveisAlerta = {
  critico: { cor: '#FF3B30', fundo: '#FFF5F5', icone: 'gpp_bad', ordem: 0 },
  atencao: { cor: '#FF9500', fundo: '#FFFAF0', icone: 'warning', ordem: 1 },
  info: { cor: '#2670D1', fundo: '#EBF8FF', icone: 'info', ordem: 2 },
};

export const estiloAlerta = (nivel) => niveisAlerta[nivel] || niveisAlerta.info;

// O alerta mais grave da lista e quem representa a linha no grid: um contrato
// com um critico e um informativo tem que aparecer como critico.
export const piorAlerta = (lista) => {
  if (!lista?.length) {
    return null;
  }
  return [...lista].sort(
    (a, b) => estiloAlerta(a?.nivel).ordem - estiloAlerta(b?.nivel).ordem
  )[0];
};
